import { Button, IconSidebarOpen, styled } from '@lessonup/ui-components';
import { TFunction } from 'i18next';
import React from 'react';

interface AiImageTabProps {
  handleGenerateWithAI: () => void;
  t: TFunction;
}

export const AiImageTab: React.FC<AiImageTabProps> = ({ handleGenerateWithAI, t }) => {
  return (
    <Wrapper>
      <Button
        buttonType="secondary"
        showStroke
        iconStart={<IconSidebarOpen />}
        buttonShape="rect"
        size="small"
        onClick={handleGenerateWithAI}
      >
        {t('imagePicker.openAiInSideBarButton')}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
